/**
 * Application Configuration
 * 
 * This file contains all application-wide configuration constants.
 * Modify APP_NAME to easily rebrand the application.
 */

export const APP_CONFIG = {
  // Application Name - Change this to rebrand the entire application
  APP_NAME: 'Yet2Book',
  
  // Application Details
  APP_TAGLINE: 'Find Your Perfect Stay',
  APP_DESCRIPTION: 'Discover and book unique accommodations',
  
  // Contact Information
  SUPPORT_EMAIL: 'support@yet2book.com',
  CONTACT_PHONE: '+971 50 123 4567',
  
  // Social Media (optional)
  SOCIAL_LINKS: {
    facebook: '',
    twitter: '',
    instagram: '',
    linkedin: ''
  }
};

// Export individual values for convenience
export const { APP_NAME, APP_TAGLINE, APP_DESCRIPTION, SUPPORT_EMAIL, CONTACT_PHONE } = APP_CONFIG;
